import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, Input, Output } from '@angular/core';

import { ImageLoadingComponent } from '@common/image-loading/image-loading.component';
import { AutoFocusDirective } from '@helper/auto-focus.directive';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';
import { WindowDetectService } from '@service/window-detect.service';

@Component({
  selector: 'app-login-input',
  templateUrl: './login-input.component.html',
  imports: [ImageLoadingComponent, AutoFocusDirective, FocusRemoverDirective],
  styleUrls: ['./login-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginInputComponent {
  readonly inputBuffer = 110;
  readonly detectService = inject(WindowDetectService);

  @Input() maxLength = 100;
  @Input() width = 310;

  value = input('');

  @Output() readonly data = new EventEmitter<string>();
}
